<template>
  <div class="list" @click="$emit('click', user)">
    <div class="item">
      <span>{{ user.客户姓名 }}:</span>{{ user.客户电话 | maskTel }}
    </div>
    <div class="item">
      <span>现跟办顾问:</span
      ><template v-if="user.跟办顾问姓名"
        >{{ user.跟办顾问姓名 }}[{{ user.跟办顾问 }}]</template
      >
    </div>
    <van-row>
      <van-col :span="12">
        <div class="item"><span>推介来源:</span>{{ user.推介来源 }}</div>
      </van-col>
      <van-col :span="12">
        <div class="item"><span>经纪人:</span>{{ user.推荐人 }}</div>
      </van-col>
    </van-row>
    <div class="item"><span>渠道公司:</span>{{ user.渠道公司 }}</div>
    <div class="item"><span>确认时刻:</span>{{ ConfirmeTime() }}</div>

    <div class="item"><span>注册时刻:</span>{{ RegisterTime() }}</div>
    <div class="item">
      <span>回访时刻:</span>
      {{ CallbackTime() }}
    </div>
    <!-- <van-cell
        :title="user.客户姓名+' '+user.客户电话"
        :value="RegisterTime(user)"
        :label="CallbackTime(user)"
        @click="$emit('click', user) "
      /> -->
  </div>
</template>
<script>
import { parseTime } from "@/utils/date";
export default {
  name: "record",
  props: ["user"],
  methods: {},
  components: {},
  methods: {
    RegisterTime() {
      return parseTime(this.user._createtime, "{y}-{m}-{d} {h}:{i}");
    },
    ConfirmeTime() {
      if (this.user.确认日期)
        return parseTime(this.user.确认日期, "{y}-{m}-{d} {h}:{i}");
    },
    CallbackTime() {
      if (this.user.回访记录)
        return parseTime(
          this.user.回访记录[0].回访时刻,
          "回访： {y}-{m}-{d} {h}:{i}"
        );
    },
  },
};
</script>
<style scoped lang="less">
.list{
  margin:3px 6px;
  border: 1px solid lightgrey ;
  padding: 3px;
  border-radius: 3px;
}
.item{
  font-size: 12px;
  line-height: 2em;
  color: darkgreen;
  span{
    color: gray;
    width: 80px;
    text-align: center;
    padding-right:  1em;
    display:inline-block;
  }
}

.right{
  display: inline-block;
  width: 160px;
  float: right;
}

//////

.items {
  background: #fff;
  box-sizing: border-box;
  //padding: 5px;
  //margin-bottom: 5px;
}
.custom-address{
font-size: 10px;
padding-top: 0px;
padding-left: 30px;
}
.custom-tel{
font-size: 12px;
padding-top: 0px;
padding-left: 30px;
}
.recordItem {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .icon,
  // .record {
  //   width: 30px;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  .icon {
    font-size: 18px;
  }
  // .record {
  //   width: 50px;
  //   color: #1989fa;
  // }
  // .message {
  //   flex: 1;
  //   //   display: flex;
  //   //   flex-direction: row;
  //   //   align-items: center;
  //   span {
  //     display: block;
  //     padding: 3px;
  //   }
  // }
}
</style>